import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-amount',
  templateUrl: './amount.component.html',
  styleUrls: ['./amount.component.scss']
})
export class AmountComponent implements OnInit {
  @Input() subscriptionPlan;
  @Input() cameraPlan;
  @Input() isCameraPlanEnabled;
  @Input() taxPercentage;

  constructor() { }

  ngOnInit() {
  }

  getTotalPrice() {
    // tslint:disable-next-line:radix
    return this.getSubTotalPrice() + this.getTaxAmount();
  }

  getSubTotalPrice() {
    if (this.isCameraPlanEnabled) {
      return this.subscriptionPlan.new_price + this.cameraPlan.new_price;
    }
    return this.subscriptionPlan.new_price;
  }

  getTaxAmount() {
    if (this.taxPercentage && this.taxPercentage > 0) {
      const subTotalPrice = this.getSubTotalPrice();
      const taxAmount = subTotalPrice * this.taxPercentage / 100;
      return Math.round(taxAmount);
    }
    return 0;
  }

}
